import React from 'react'
import ReactDOM from 'react-dom/client'
import { ChakraProvider } from '@chakra-ui/react'
import { ClerkProvider } from '@clerk/clerk-react'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { PostHogProvider } from 'posthog-js/react'
import AppRouter from './AppRouter'
import theme from './theme'
import './index.css'

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
}

function App() {
  return (
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={posthogOptions}>
      <ChakraProvider theme={theme}>
        <AppRouter />
        <Analytics />
        <SpeedInsights />
      </ChakraProvider>
    </PostHogProvider>
  )
}

function Root() {
  if (CLERK_PUBLISHABLE_KEY) {
    return (
      <ClerkProvider 
        publishableKey={CLERK_PUBLISHABLE_KEY}
        afterSignOutUrl="/"
      >
        <App />
      </ClerkProvider>
    )
  }
  
  console.log('Clerk publishable key not configured - running in development mode without authentication')
  return <App />
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
)
